export function allowNumericKeysOnly(e) {
  if (
    e.charCode == 8 ||
    e.charCode == 0 ||
    e.charCode == 13 ||
    (e.charCode >= 48 && e.charCode <= 57)
  ) {
    if (e.target.value.length >= 4 && (e.charCode >= 48 && e.charCode <= 57)) {
      e.preventDefault();
    }
    return;
  } else {
    e.preventDefault();
  }
}

22222222


// WEBPACK FOOTER //
// ./src/components_new/addListing/utils.js